var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPredefinedOfferModalDetailsHeadingIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 73,
  height: 73,
  viewBox: "0 0 73 73",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 36.5,
  cy: 36.5,
  r: 34,
  fill: "url(#paint0_linear_5265_1547)",
  stroke: "white",
  strokeWidth: 5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M45.75 23.5C47.4 23.5 48.75 24.85 48.75 26.5V29.9199C49.635 30.4449 50.25 31.39 50.25 32.5V41.5C50.25 42.61 49.635 43.5551 48.75 44.0801V47.5C48.75 49.15 47.4 50.5 45.75 50.5H24.75C23.085 50.5 21.75 49.15 21.75 47.5V26.5C21.75 24.85 23.085 23.5 24.75 23.5H45.75ZM24.75 47.5H45.75V44.5H36.75C35.1 44.5 33.75 43.15 33.75 41.5V32.5C33.75 30.85 35.1 29.5 36.75 29.5H45.75V26.5H24.75V47.5ZM36.75 41.5H47.25V32.5H36.75V41.5ZM41.25 34.75C42.4926 34.75 43.5 35.7574 43.5 37C43.5 38.2426 42.4926 39.25 41.25 39.25C40.0074 39.25 39 38.2426 39 37C39 35.7574 40.0074 34.75 41.25 34.75Z",
  fill: "white"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5265_1547",
  x1: 5,
  y1: 36.4965,
  x2: 68.0008,
  y2: 36.4965,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPredefinedOfferModalDetailsHeadingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/predefined-offer-modal-details-heading-icon.5bc925dcacb548b1a54ecda75e11f1f8.svg";